App.factory('profileProtegesService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function ProfileProtegesService() {
        this.dataProtegesUser = function(data) {
            return baseService.post(Config.API_URL + '/relative/', data).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };

        this.allProtegesUser = function(data) {
            return baseService.get(Config.API_URL + '/relative/all', data).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };

        this.addProtegesUser = function(data) {
            return baseService.put(Config.API_URL + '/relative/', data).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };

        this.editProtegesUser = function(data) {
            return baseService.post(Config.API_URL + '/relative/update', data).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };

        this.deleteProtegesUser = function(id) {
            return baseService.delete(Config.API_URL + '/relative/' + id).then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };
    }
    return new ProfileProtegesService();
}]);